import { defineComponent, ref, watch } from "vue";
import { isMobile } from "../../utils/environment.mjs";
import SvgIcon from "../common/base/SvgIcon.vue.mjs";
import Dialog from "../common/base/Dialog/index.mjs";
import ArrowStrokeBackIcon from "../common/icons/ArrowStrokeBackIcon.vue.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "PanelContainer",
  props: {
    visible: { type: Boolean },
    title: null,
    editButtonText: { type: [Boolean, String] },
    width: null
  },
  emits: ["input", "edit"],
  setup(__props, { emit }) {
    const props = __props;
    const panelVisible = ref(false);
    const closePanel = () => {
      emit("input", false);
    };
    watch(
      () => props.visible,
      (val) => {
        panelVisible.value = val;
      },
      {
        immediate: true
      }
    );
    watch(
      panelVisible,
      (val) => {
        emit("input", val);
      },
      { immediate: true }
    );
    const handleEdit = () => emit("edit");
    return { __sfc: true, emit, props, panelVisible, closePanel, handleEdit, isMobile, SvgIcon, TuiDialog: Dialog, ArrowStrokeBackIcon };
  }
});
export {
  _sfc_main as default
};
